import { Routes } from '@angular/router';
import { permissionGuard } from './shared/guards/permission.guard';
import { authGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    title: 'Redirect',
    loadComponent: () =>
      import('./shared/components/redirector/redirector.component').then((m) => m.RedirectorComponent),
  },
  {
    path: 'redirector',
    title: 'Redirect',
    loadComponent: () =>
      import('./shared/components/redirector/redirector.component').then((m) => m.RedirectorComponent),
  },
  {
    path: 'auth/login',
    title: 'Login',
    loadComponent: () =>
      import('./modules/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'auth/forgot-password',
    title: 'Forgot Password',
    loadComponent: () =>
      import('./modules/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'auth/check-inbox',
    title: 'Check Inbox',
    loadComponent: () =>
      import('./modules/auth/check-inbox/check-inbox.component').then((m) => m.CheckInboxComponent),
  },
  {
    path: 'auth/reset-password',
    title: 'Reset Password',
    loadComponent: () =>
      import('./modules/auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'session-expired',
    title: 'Session Expired',
    loadComponent: () =>
      import('./shared/components/session-expired/session-expired.component').then(
        (m) => m.SessionExpiredComponent
      ),
  },
  {
    path: 'properties',
    title: 'Properties',
    loadChildren: () =>
      import('./modules/properties/properties.routes').then(
        (m) => m.PROPERTIES_ROUTES
      ),
    canMatch: [authGuard],
    canActivate: [permissionGuard],
    data: { permission: 'transactions.read' },
  },
  {
    path: 'underwrites',
    title: 'Underwrites',
    loadChildren: () =>
      import('./modules/underwrites/underwrites.routes').then(
        (m) => m.UNDERWRITES_ROUTES
      ),
    canMatch: [authGuard],
    canActivate: [permissionGuard],
    data: { permission: 'underwrites.read' },
  },
  {
    path: 'contact-admin',
    title: 'Contact Admin',
    loadComponent: () =>
      import('./shared/components/contact-admin/contact-admin.component').then(
        (m) => m.ContactAdminComponent
      ),
  },
  {
    path: 'access-denied',
    title: 'Access Denied',
    loadComponent: () =>
      import('./shared/components/access-denied/access-denied.component').then(
        (m) => m.AccessDeniedComponent
      ),
  },
  {
    path: 'contacts',
    title: 'Contacts',
    loadChildren: () =>
      import('./modules/contact/contact.routes').then((m) => m.CONTACT_ROUTES),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: ['contacts.contractors.read', 'contacts.capitalproviders.read'], mode: 'any' },
  },
  {
    path: 'settings',
    title: 'Settings',
    loadChildren: () =>
      import('./modules/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
    canActivate: [authGuard]
  },
  {
    path: 'workflows',
    title: 'Workflows',
    loadChildren: () =>
      import('./modules/workflows/workflows.routes').then((m) => m.WORKFLOWS_ROUTES),
    canActivate: [authGuard]
  },
  {
    path: 'property-transactions',
    title: 'Transactions',
    loadChildren: () =>
      import('./modules/transactions/transactions.routes').then((m) => m.TRANSACTIONS_ROUTES),
      canMatch: [authGuard],
      canActivate: [permissionGuard],
      data: { permission: 'transactions.read' }
  },
  {
    path: 'documents',
    title: 'Documents',
    loadComponent: () =>
      import('./modules/documents/documents.component').then(
        (m) => m.DocumentsComponent
      ),
      canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    title: 'Dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
    canMatch: [authGuard],
},
{
    path: 'change-requests',
    title: 'Change Requests',
    loadChildren: () =>
      import('./modules/change-requests/change-requests.routes').then((m) => m.CHANGE_REQUESTS_ROUTES),
    canMatch: [authGuard],
    canActivate: [permissionGuard],
    data: { permission: 'changerequests.read' }
  },
];
